import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enExpenses from './locales/en/expenses.json';
import enAnalytics from './locales/en/analytics.json';
import enSettings from './locales/en/settings.json';
import enLanding from './locales/en/landing.json';
import enCategories from './locales/en/categories.json';
import enAsk from './locales/en/ask.json';

import heCommon from './locales/he/common.json';
import heDashboard from './locales/he/dashboard.json';
import heExpenses from './locales/he/expenses.json';
import heAnalytics from './locales/he/analytics.json';
import heSettings from './locales/he/settings.json';
import heLanding from './locales/he/landing.json';
import heCategories from './locales/he/categories.json';
import heAsk from './locales/he/ask.json';

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    expenses: enExpenses,
    analytics: enAnalytics,
    settings: enSettings,
    landing: enLanding,
    categories: enCategories,
    ask: enAsk,
  },
  he: {
    common: heCommon,
    dashboard: heDashboard,
    expenses: heExpenses,
    analytics: heAnalytics,
    settings: heSettings,
    landing: heLanding,
    categories: heCategories,
    ask: heAsk,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'he', // Default language
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'dashboard', 'expenses', 'analytics', 'settings', 'landing', 'categories', 'ask'],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
